// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","742":"combined"}[chunkId] || chunkId) + "." + {"594":"3c0952ab","742":"3e6ced69","819":"d2c52afa"}[chunkId] + ".js";
};